import { useTranslation } from 'react-i18next';

const featureIcons = [
  'ri-shield-star-fill',
  'ri-truck-fill',
  'ri-user-star-fill',
  'ri-price-tag-3-fill',
  'ri-global-fill',
  'ri-customer-service-fill',
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = featureIcons.map((icon, i) => ({
    icon,
    title: t(`feat${i}_title`),
    desc: t(`feat${i}_desc`),
    highlight: t(`feat${i}_highlight`),
  }));

  return (
    <section id="features" className="w-full py-16 md:py-28 bg-[#1C2E4A]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="text-[#E8762B] text-xs font-semibold tracking-widest mb-4">{t('features_section_label')}</div>
          <h2 className="text-3xl md:text-4xl font-black text-white" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            {t('features_title')}
          </h2>
          <p className="text-white/50 mt-4 text-sm">{t('features_subtitle')}</p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#E8762B]/40 rounded-2xl p-5 md:p-7 transition-all group cursor-default"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#E8762B]/15 rounded-xl mb-4 md:mb-5 group-hover:bg-[#E8762B]/25 transition-colors">
                <i className={`${f.icon} text-xl md:text-2xl text-[#E8762B]`}></i>
              </div>
              <h3 className="text-white font-bold text-base md:text-lg mb-2 md:mb-3">{f.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4 md:mb-5">{f.desc}</p>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-[#E8762B]"></div>
                <span className="text-[#E8762B] text-xs font-semibold">{f.highlight}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-10 md:mt-16 bg-[#E8762B] rounded-2xl p-7 md:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <div className="text-white text-xl md:text-2xl font-black mb-1">{t('features_banner_title')}</div>
            <div className="text-white/80 text-sm">{t('features_banner_subtitle')}</div>
          </div>
          <div className="flex items-center gap-4 md:gap-6 shrink-0">
            <div className="text-white">
              <a href="tel:02-6941-1750" className="text-lg md:text-xl font-black hover:underline cursor-pointer whitespace-nowrap">02-6941-1750</a>
            </div>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-[#E8762B] px-5 md:px-6 py-2.5 md:py-3 rounded-md font-bold text-sm hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('features_banner_phone_cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
